import { ArrowRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { applicationNextStep } from '../../../../shared/src/utils/applicationNextStep';

/** Stage guidance with an optional application-specific action. */
export function ApplicationNextStep({ status, variant = 'compact', action }: { status: string; variant?: 'compact' | 'detail'; action?: ReactNode }) {
  const guidance = applicationNextStep(status);
  if (guidance.kind === 'unknown') return action ? <div className="d-flex justify-content-end mb-4">{action}</div> : null;
  return (
    <div className={`application-next-step application-next-step--${variant}`}>
      <ArrowRight size={variant === 'detail' ? 16 : 12} aria-hidden="true" className="application-next-step__icon" />
      <span className="application-next-step__copy">
        <span className="application-next-step__label">Next step: </span>
        <span className="application-next-step__value">{guidance.text}</span>
      </span>
      {action && <div className="application-next-step__action">{action}</div>}
    </div>
  );
}
